import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import CustomList from '../../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../../config/config';
import { loadData } from '../../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectionProcessId } = useParams();
    const queryParams = new URLSearchParams(location.search);
    const initialProcessId = selectionProcessId || queryParams.get('psp_selection_process_id') || '';

    const pathFrontEnd = selectionProcessId
        ? `/psp-selectionprocesses/${selectionProcessId}/vacancies/`
        : '/psp-selectionprocesses/vacancies/';

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}psp/selectionprocessvacancies/delete`,
        endpoint: `${config.endpoints.backend}psp/selectionprocessvacancies/getall`
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        values: initialProcessId ? { psp_selection_process_id: initialProcessId } : {},
        fields: [
            {
                name: 'psp_role_id',
                type: 'select',
                label: 'Função / Cargo',
                options: [],
                optionsEndpoint: {
                    endpoint: `${config.endpoints.backend}psp/roles/getall`,
                    label: 'name',
                    value: 'id'
                },
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'academic_background',
                type: 'select',
                label: 'Escolaridade',
                options: [
                    { label: 'Ensino Fundamental', value: 'Ensino Fundamental' },
                    { label: 'Ensino Médio', value: 'Ensino Médio' },
                    { label: 'Ensino Técnico', value: 'Ensino Técnico' },
                    { label: 'Graduação', value: 'Graduação' },
                    { label: 'Pós-Graduação', value: 'Pós-Graduação' },
                    { label: 'Mestrado', value: 'Mestrado' },
                    { label: 'Doutorado', value: 'Doutorado' },
                    { label: 'Pós-Doutorado', value: 'Pós-Doutorado' }
                ],
                validations: { required: false },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Vagas dos Processos Seletivos',
        labelTitleButtonAdd: 'Incluir nova Vaga',
        fieldsShowOnDelete: ['title'],
        formFilters: filters,
        filter: initialProcessId ? { psp_selection_process_id: initialProcessId } : {},
        columns: [
            {
                name: 'title',
                label: 'Título da Vaga',
                sortable: true
            },
            {
                name: 'selection_process_title',
                label: 'Processo Seletivo',
                sortable: true,
                cell: (row) => (
                    <div>
                        <strong>{row.selection_process_title || '-'}</strong>
                        {row.selection_process_edital_number && (
                            <div className="small text-muted">Edital: {row.selection_process_edital_number}</div>
                        )}
                    </div>
                )
            },
            {
                name: 'role_name',
                label: 'Função / Cargo',
                sortable: true
            },
            {
                name: 'academic_background',
                label: 'Escolaridade Exigida',
                sortable: true,
                cell: (row) => row.academic_background || '-'
            },
            {
                name: 'has_exam',
                label: 'Prova',
                sortable: true,
                width: '8%',
                cell: (row) => (row.has_exam ? 'Sim' : 'Não')
            }
        ]
    };

    list = { ...list, ...paths };

    const buttons = [
        {
            name: 'back_to_processes',
            label: 'Processos Seletivos',
            icon: 'fas fa-arrow-left',
            class: 'btn btn-outline-secondary',
            tooltipLabel: 'Voltar para listagem de Processos Seletivos',
            callback: () => navigate('/psp-selectionprocesses/list')
        }
    ];

    return (
        <div>
            <CustomListContainer
                canAdd={false}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                buttons={buttons}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
